// Clerk configuration for ARMS application
// This file centralizes all Clerk-related configuration including redirects

const getClerkConfig = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const baseUrl = isDevelopment 
    ? 'http://localhost:3000' 
    : 'https://arms.elsaifoundry.ai';

  return {
    // Base configuration
    publishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY,
    baseUrl: baseUrl,
    
    // Main redirect URL
    redirectUrl: `${baseUrl}/dashboard`,
    
    // Organization-related redirects
    organization: {
      afterCreateOrganizationUrl: '/dashboard',
      afterSwitchOrganizationUrl: '/dashboard',
      afterLeaveOrganizationUrl: '/dashboard',
      afterRemoveMemberUrl: '/dashboard',
      afterUpdateOrganizationUrl: '/dashboard',
      afterInviteMemberUrl: '/dashboard',
    },
    
    // User-related redirects
    user: {
      afterSignUpUrl: '/dashboard',
      afterSignInUrl: '/dashboard',
      afterSignOutUrl: '/',
      afterUpdateProfileUrl: '/dashboard',
    },
    
    // Invite-related redirects (this fixes the main issue)
    invitations: {
      afterAcceptInvitationUrl: '/dashboard',
      afterDeclineInvitationUrl: '/dashboard',
      afterSkipInvitationUrl: '/dashboard', // Key fix for the redirect issue
      afterInviteMemberUrl: '/dashboard',
    },
    
    // General redirects
    general: {
      defaultRedirectUrl: '/dashboard',
      homeUrl: '/dashboard',
    },
    
    // Appearance customization
    appearance: {
      baseTheme: 'light',
      variables: {
        colorPrimary: '#2563eb', // Blue color matching your app
        colorText: '#1f2937',
        colorBackground: '#ffffff',
      },
    },
  };
};

export default getClerkConfig; 